import { AdmissionMapTranslations } from "../models/admission-map-translaction-model";

export const ptBR: AdmissionMapTranslations = {
  title: 'Relatório - Mapa de Internação',
  tabs: {
    admission: 'Mapa',
    reports: 'Meus Relatórios',
  },
  status: {
    changesSaved: 'Alterações salvas',
  },
  reports: {
    layoutName: 'Relatório de Procedimentos',
  },
  fields: {
    carrier: 'Operadora',
    contract: 'Contrato',
    patient: 'Paciente',
    passwordStatus: 'Situação Senha',
    cidCode: 'CID',
    cidDescription: 'Descrição do CID',
    speciality: 'Especialidade',
    urgencyType: 'Urgência / Eletiva',
    highCost: 'Alto Custo',
    unauthorized: 'Elegível Acompanhamento',
    icu: 'UTI',
    medicalReport: 'Relatório Médico',
    specialCase: 'Caso Especial',
    evolution: 'Evolução',
    note: 'Observação',
    financialGroup: 'Grupo Financeiro',
    startPeriod: 'Período Inicial',
    endPeriod: 'Período Final',
  },
  filter: {
    withHistory: 'Com Histórico de Registros',
    expandSearch: 'Expandir Opções de Pesquisa',
    clear: 'Limpar Filtros',
    placeholders: {
      select: 'Selecione',
      startDate: 'Data início',
      endDate: 'Data fim',
    },
  },
  actions: {
    export: 'Exportar',
    viewHistory: 'Ver Histórico',
  },
  table: {
    noData: 'Nenhum registro encontrado para os filtros informados.',
    headers: {
      note: 'Obs',
    },
  },
  dialog: {
    editObservationTitle: 'Editar observação',
  },
  messages: {
    exportError: 'Erro ao exportar Mapa de Admissão',
    groupsError: 'Erro ao buscar Grupos Financeiros',
    carriersError: 'Erro ao buscar Operadoras',
    contractsError: 'Erro ao buscar Contratos',
    passwordStatusesError: 'Erro ao buscar as situações de senha',
    urgencyTypesError: 'Erro ao buscar os tipos de urgência',
    highCostTypesError: 'Erro ao buscar os tipos de alto custo',
    searchError: 'Erro ao buscar o mapa de internação',
    historyError: 'Erro ao buscar o histórico de admissão',
    updateError: 'Erro ao atualizar o mapa de internação',
    noPermission: 'Você não tem permissão de realizar essa ação.',
    noPermissionTop: 'Sem permissão',
    saveError: 'Não foi possível salvar sua alteração. Verifique sua conexão com a internet e tente novamente.',
    noDataText: 'Nenhum dado encontrado.',
    loadingText: 'Carregando...',
    noResultText: 'Nenhum resultado encontrado.',
    notSpecified: 'Não Especificado',
    validationFields: {
      note: 'O campo "Observação" é obrigatório.',
      companionAuthorized: 'O campo "Elegível Acompanhamento" é obrigatório.',
      evolution: 'O campo "Evolução" é obrigatório.',
      specialCase: 'O campo "Caso Especial" é obrigatório.',
      highCost: 'O campo "Alto Custo" é obrigatório.',
      cidDescription: 'O campo "Descrição do CID" é obrigatório.',
      urgencyType: 'O campo "Urgência/Eletiva" é obrigatório.',
      uti: 'O campo "UTI" é obrigatório.',
      speciality: 'O campo "Especialidade" é obrigatório.',
    },
  },
  passwordStatuses: {
    authorized: 'Autorizado',
    released: 'Liberada',
    denied: 'Negada',
    pending: 'Pendente',
    canceled: 'Cancelado',
    analysis: 'Em Análise',
  },
  boolean: {
    yes: 'Sim',
    no: 'Não',
  },
  history: {
    types: {
      added: 'Adicionado',
      updated: 'Alterado',
      deleted: 'Excluído',
    },
  },
};